export interface SignalRNotificationModel {
  id: number;
  title: string;
  message: string;
  type?: 'info' | 'success' | 'warning' | 'error';
  isRead: boolean;
  validFrom?: string | Date;
  createdOn?: string | Date;
  createdBy?: number;
  deleted?: boolean;
  redirectionUrl?: string;
  isBroadcast?: boolean;
  timestamp?: Date;   // used internally for display
}